const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Tags {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: this.uri,
    });
}

export default new Tags('/cms/v1/tags');



// WEBPACK FOOTER //
// ./src/libraries/api/tag.tsx